import { render, staticRenderFns } from "./ItemTable.vue?vue&type=template&id=4aeab7f2&"
import script from "./ItemTable.vue?vue&type=script&lang=ts&"
export * from "./ItemTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports